var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-dialog',{attrs:{"width":"890px"},scopedSlots:_vm._u([{key:"head",fn:function(){return [_vm._v("\n        请选择感兴趣的类型\n    ")]},proxy:true}]),model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._v(" "),_c('dialog-body',{on:{"close":_vm.closeHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }